var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{attrs:{"id":"home"}},[_c('Banner'),_c('Osvdm'),_c('Sobre'),_c('Especial'),_c('Lote'),_c('Bailes'),_c('Equipe'),_c('h1',[_vm._v("Home")]),_c('Parallax')],1)}
var staticRenderFns = []

export { render, staticRenderFns }